import { useContext } from 'react'
import { LoyaltyCouponsContext } from '../context/LoyaltyCouponsContext'

export const useLoyaltyCouponsContext = () => {
  const ctx = useContext(LoyaltyCouponsContext)
  if (!ctx) {
    throw new Error(
      'useLoyaltyCouponsContext must be used within <LoyaltyCouponsProvider />',
    )
  }
  return ctx
}

// Non-throwing variant for presentational coupon components that also render
// outside the catalog (e.g. the campaign builder's reward picker, which has no
// LoyaltyCouponsProvider above it). Returns null instead of throwing so those
// components can degrade rather than crash the page.
export const useOptionalLoyaltyCouponsContext = () =>
  useContext(LoyaltyCouponsContext) ?? null
